module.exports = __webpack_public_path__ + "static/img/fallback_car.53c2ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fallback_car.png
// module id = XE13
// module chunks = 1